import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import Breadcrumb from "../../../../../components/Generic/Breadcrump";
import Fleets from "../Resources/FleetPage";
import CronjobAutomate from "./Automate";
import AutomationPage from "./Automation";
import Branch from "./Branch";
import { GeneralSettingTab } from "./General";
import NotifyParty from "./NotifyParty";
import OfficesPage from "./Offices";
import Ports from "./Ports";
import Signature from "./Signature";
import UploadCentre from "./UploadCentre";
import Warehousing from "./Warehousing";
import HSCommodityCode from "./HSCommodityCode";
import { useAppState } from "Context/StateContext";
import { checkResourceCan, FN_NAMES, hasPermission } from "Util/permissions";
import { ResourceCanEnum, ResourceName } from "Util/enums/accessRule";

interface Props {
  history: any;
  tabName: string;
  subTabName: string;
}

export const ConfigurationsTab = ({ tabName, subTabName }: Props) => {
  const { t: translate } = useTranslation();
  const { userPermissions } = useAppState();
  const [configurationPermission, setConfigurationPermission] = useState<{
    general: {
      edit: boolean;
      create: boolean;
    };
    warehouse: {
      edit: boolean;
      create: boolean;
    };
    offices: {
      edit: boolean;
      create: boolean;
    };
    branch: {
      edit: boolean;
      create: boolean;
    };
    automation: {
      edit: boolean;
    };
    uploadCentre: {
      edit: boolean;
    };
    automate: {
      edit: boolean;
    };
    port: {
      edit: boolean;
    };
    hsCommodityCode: {
      edit: boolean;
    };
  }>({
    general: {
      edit: false,
      create: false,
    },
    warehouse: {
      edit: false,
      create: false,
    },
    branch: {
      edit: false,
      create: false,
    },
    offices: {
      edit: false,
      create: false,
    },
    automation: {
      edit: false,
    },
    uploadCentre: {
      edit: false,
    },
    automate: {
      edit: false,
    },
    port: {
      edit: false,
    },
    hsCommodityCode: {
      edit: false,
    },
  });

  useEffect(() => {
    if (userPermissions && userPermissions?.length > 0) {
      setConfigurationPermission({
        general: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_GENERAL_EDIT),
          create:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_GENERAL_ADD_NEW),
        },
        warehouse: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_WAREHOUSING_EDIT),
          create:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_WAREHOUSING_ADD_NEW),
        },
        branch: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_BRANCHES_EDIT),
          create:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_BRANCHES_ADD_NEW),
        },
        offices: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_OFFICES_EDIT),
          create:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_OFFICES_ADD_NEW),
        },
        automation: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_AUTOMATION_EDIT),
        },
        uploadCentre: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_UPLOAD_CENTRE_EDIT),
        },
        automate: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_AUTOMATE_EDIT),
        },
        port: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_PORTS_EDIT),
        },
        hsCommodityCode: {
          edit:
            checkResourceCan(userPermissions, ResourceName.CONFIGURATIONS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_CONFIGURATIONS_HS_COMMODITY_CODE_EDIT),
        },
      });
    }
  }, [userPermissions]);

  const getCurrentPage = () => {
    switch (tabName) {
      case "general":
        return (
          <GeneralSettingTab permission={configurationPermission.general} tabName={subTabName} />
        );
      case "warehousing":
        return <Warehousing permission={configurationPermission.warehouse} tabName={subTabName} />;
      case "branches":
        return <Branch permission={configurationPermission.branch} />;
      case "automation":
        return <AutomationPage permission={configurationPermission.automation} />;
      case "fleet":
        return (
          <div className="mt-4 mb-4 ml-4 mr-4">
            {/* <header className="mb-4">
              <Breadcrumb
                items={[
                  { title: translate("configurations") },
                  {
                    title: translate("fleet"),
                    color: "#465869",
                    dataCy: "breadcrumbsSubTitle",
                  },
                ]}
              />
            </header> */}
            <Fleets />
          </div>
        );
      case "offices":
        return <OfficesPage permission={configurationPermission.offices} />;
      case "ports":
        return <Ports permission={configurationPermission.port} />;
      case "signature":
        return <Signature />;
      case "notifyParty":
        return <NotifyParty />;
      case "automate":
        return <CronjobAutomate />;
      case "uploadCentre":
        return <UploadCentre permission={configurationPermission.uploadCentre} />;
      case "hsCommodityCode":
        return <HSCommodityCode permission={configurationPermission.hsCommodityCode} />;
      default:
        return null;
    }
  };

  return getCurrentPage();
};
